export default __webpack_public_path__ + "static/media/animation-key3.3d23913c.gif";